import React from 'react'

const QrCodePP = () => {
  return (
    <div style={{backgroundColor: "red"}}>QrCodePP</div>
  )
}

export default QrCodePP